export enum CipApplicationStatus {
  APPROVED = 'approved',
  ARCHIVED = 'archived',
  AWAITING_DOCUMENTS = 'awaitingDocuments',
  DENIED = 'denied',
  NOT_SUBMITTED = 'notSubmitted',
  PENDING_REVIEW = 'pendingReview',
}

export enum MemberHsaDetailsStatus {
  active = 'active',
  closed = 'closed',
  frozen = 'frozen',
  pending = 'pending',
}
